import { Card } from "@devhop/ui";
import type { ChecklistResultStatsResult } from "@/modules/checklist/domain/types/result";

type ChecklistResultByDepartmentProps = {
  stats: ChecklistResultStatsResult;
};

export function ChecklistResultByDepartment({
  stats,
}: ChecklistResultByDepartmentProps) {
  if (stats.byDepartment.length === 0) return null;

  return (
    <Card className="gap-0 p-6">
      <h2 className="mb-4 font-semibold text-lg">ສະຖິຕິຕາມພະແນກ</h2>
      <div className="space-y-3">
        {stats.byDepartment.map((dept) => {
          const t = dept.total || 1;
          const donePct = Math.round((dept.completed / t) * 100);
          return (
            <div key={dept.departmentId ?? "none"}>
              <div className="mb-1 flex flex-wrap items-center justify-between gap-2 text-sm">
                <span className="font-medium">
                  {dept.departmentName || "ບໍ່ລະບຸພະແນກ"}
                </span>
                <span className="text-muted-foreground">
                  ທັງໝົດ {dept.total} · ສຳເລັດ {dept.completed} · ກຳລັງເຮັດ{" "}
                  {dept.inProgress} · ຍົກເລີກ {dept.cancelled}
                </span>
              </div>
              <div className="h-4 w-full overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full bg-green-500 transition-all"
                  style={{ width: `${donePct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
